import {
  getActionNameWithStatus,
  getResetAction,
} from "../../constants/actions-methods";
import { requestStatus } from "../../constants/request";
import { serverApis } from "../../constants/server-apis";

export const shipmentNumnberListReducer = (state = [], action) => {
  const actionName = serverApis.getShipmentNumberList.actionName;
  switch (action.type) {
    case getActionNameWithStatus(actionName, requestStatus.SUCCESS):
      return action.json.shipments;

    case getResetAction(actionName):
      return [];
    default:
      return state;
  }
};
